export const isTrue = (value) => value === true || value === 1 || value === 't' || value === 'T';
export const isFalse = (value) => value === false || value === 0 || value === 'f' || value === 'F';
